<template>
    <div>
        <nav-common :nav="nav"></nav-common>
            <div class="center-intro">
      <div class="center-intro-content">guali</div>
    </div>
    </div>
</template>
<style scoped>
.center-intro {
  width: 100%;
  background: #e6ecf2;
  border: 1px solid #e6ecf2;
  box-sizing: border-box;
  border-radius: 10px 10px 0 0;
  padding: 20px 0 0 0;
  box-sizing: border-box;
}
.center-intro-content {
  width: 100%;
  background: #fff;
  color: #222;
  padding: 40px;
  box-sizing: border-box;
}
</style>
<script>
import navCommon from "@/components/views/common/nav.vue";
export default {
  data() {
    return {
      nav: {
        firsttitle: "科研与国际合作",
        firstrouteName: "CooperMajor",
        secondtitle: "科研项目管理",
        secondrouteName: "",
        thirdtitle: "",
        thirdrouteName: ""
      }
    };
  },
  components: {
    navCommon
  }
};
</script>




// WEBPACK FOOTER //
// src/components/views/Cooperation/Children/manageMent.vue